import { styled } from '../../../theme/stitches.config';

export const SMPProviderLogo = styled.withConfig({ displayName: 'SMPProviderLogo' })('a', {
  display: 'block',
  borderRadius: '$1',
  height: '100%',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  cursor: 'pointer',
  textDecoration: 'none',
  outline: 'none',

  '&.disable-interaction': {
    cursor: 'default',
  },
});
